var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAerialIgnitionFieldObs = function SvgAerialIgnitionFieldObs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aerial-ignition-field-obs_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M8.972 6.511a1.86 1.86 0 1 1-2.63 2.63 1.86 1.86 0 0 1 2.63-2.63m5.26 4.133a1.86 1.86 0 1 0-2.63-2.63 1.86 1.86 0 0 0 2.63 2.63m-3.382 3.381a1.86 1.86 0 1 0-2.63-2.63 1.86 1.86 0 0 0 2.63 2.63m.752 5.26a1.86 1.86 0 1 0-2.63-2.63 1.86 1.86 0 0 0 2.63 2.63m3.756-6.387a1.86 1.86 0 1 1-2.63 2.63 1.86 1.86 0 0 1 2.63-2.63m3.758-1.127a1.86 1.86 0 1 0-2.63-2.63 1.86 1.86 0 0 0 2.63 2.63",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    fillRule: "evenodd",
    d: "M12.09 21.6a9.6 9.6 0 0 0 9.6-9.6 9.6 9.6 0 1 0-9.6 9.6m0 2.4c6.628 0 12-5.373 12-12s-5.372-12-12-12c-6.627 0-12 5.373-12 12s5.373 12 12 12",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "aerial-ignition-field-obs_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAerialIgnitionFieldObs;